import { ID } from '@griply/types';

export const taskIdSeparator = '--';

export const encodeTaskId = (sectionId: ID, taskId: ID): ID =>
  `${sectionId}${taskIdSeparator}${taskId}`;

export const decodeTaskId = (id: ID): ID => {
  const idx = id.indexOf(taskIdSeparator);
  if (idx === -1) {
    return id;
  }
  return id.slice(idx + taskIdSeparator.length);
};

export const getSectionIdFromEncodedTaskId = (id: ID): ID | undefined => {
  const idx = id.indexOf(taskIdSeparator);
  if (idx === -1) {
    return undefined;
  }
  return id.slice(0, idx);
};
